const guestUser = {
  id: null,
  email: '',
  first_name: '',
  last_name: ''
}

export default (state = guestUser, action) => {
  switch (action.type) {
    case 'SET_CURRENT_USER':
      return action.payload ? action.payload : guestUser
    case 'CLEAR_CURRENT_USER':
      return guestUser
    default:
      return state
  }
}
